import { Form, Formik } from "formik";
import Button from "../UI/Button";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { useToast } from "../UI/Toast/useToast";
// @ts-expect-error pure js
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import {
  contactIV,
  contactSchema,
  type Contact,
} from "../../models/carnetAdresse";
// @ts-expect-error pure js
import TextInput from "../UI/TextInput";
// @ts-expect-error pure js
import TextArea from "../UI/TextArea";
// @ts-expect-error pure js
import AffectationSelect from "../UI/AffectationSelect.jsx";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../UI/ModalDialog";
import styles from "./ContactForm.module.css";

interface ContactFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contact: Contact | null;
  profileId: number | null;
  onSubmit: (values: Record<string, unknown>) => Promise<void>;
  onDelete: (id: number) => Promise<void>;
}

export default function ContactForm({
  open,
  onOpenChange,
  contact,
  profileId,
  onSubmit,
  onDelete,
}: ContactFormProps) {
  const initialValues = toInitialValuesFromSchema(
    contactSchema,
    contact,
    contactIV,
  );
  const toast = useToast();

  async function submitHandler(
    values: Record<string, unknown>,
    { resetForm }: { resetForm: () => void },
  ) {
    const sanitizedValues = sanitizeValues(values);
    try {
      await onSubmit(sanitizedValues);
      resetForm();
    } catch (err) {
      toast.error({ title: handleAPIError(err) });
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={contactSchema}
      onSubmit={submitHandler}
    >
      {({ resetForm }) => (
        <ModalDialog
          size="sm"
          open={open}
          header={contact ? "Modifier un contact" : "Ajouter un contact"}
          onOpenChange={(nextOpen) => {
            if (!nextOpen) {
              resetForm();
            }
            onOpenChange(nextOpen);
          }}
        >
          <Form>
            <ModalDialogBody className={styles.form}>
              <AffectationSelect mandatory />
              <TextInput
                type="text"
                label="Nom"
                name="nom"
                placeholder="DUPONT"
                marginForm=""
                mandatory
              />
              <TextInput
                type="text"
                label="Prénom"
                name="prenom"
                placeholder="André"
                marginForm=""
              />
              <TextInput
                type="text"
                label="Téléphone"
                name="telephone"
                placeholder="0699222967"
                marginForm=""
              />
              <TextInput
                type="text"
                label="E-mail"
                name="mail"
                placeholder="adupont@qalimo.fr"
                marginForm=""
              />
              <TextInput
                type="text"
                label="Entreprise"
                name="entreprise"
                placeholder="Plomberie SARL"
                marginForm=""
              />
              <TextArea name="note" label="Note" rows={4} marginForm="" />
            </ModalDialogBody>
            <ModalDialogFooter>
              {contact && (
                <Button
                  type="button"
                  variant="secondary"
                  requiresWrite
                  profileId={profileId}
                  onClick={async () => {
                    if (
                      window.confirm(
                        "Voulez-vous vraiment supprimer ce contact ?",
                      )
                    ) {
                      try {
                        await onDelete(contact.id);
                      } catch (err) {
                        toast.error({ title: handleAPIError(err) });
                      }
                    }
                  }}
                >
                  Supprimer
                </Button>
              )}
              <FormikSubmitButton
                requiresWrite={contact != null}
                profileId={contact != null ? profileId : undefined}
              >
                Valider
              </FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        </ModalDialog>
      )}
    </Formik>
  );
}
